export default __webpack_public_path__ + "img/f59c4a285972b255f0db963b4b3ad08d.png";